import Head from "next/head";
import type { WorkspaceMark } from "./mark";
import { formatTabTitle } from "./title";
export const WorkspaceMarkHead = (props: {
  mark: WorkspaceMark | null;
  showNameInTitle?: boolean;
  displayName: string;
  appTitle: string;
}) => (
  <Head>
    <title>{formatTabTitle(props)}</title>
  </Head>
);
